const questions = [
    {
        question: "I feel sad and low",
        options: ["Never", "Hardly ever", "Some of time", "Most of the time", "All of the time"]
    },
    {
        question: "I feel disinterested in things that earlier seemed pleasurable",
        options: ["Never", "Hardly ever", "Some of time", "Most of the time", "All of the time"]
    },
    {
        question: "I feel I should be (or I am being) punished",
        options: ["Never", "Hardly ever", "Some of time", "Most of the time", "All of the time"]
    },
    {
        question: "I have difficulty making decisions",
        options: ["Never", "Hardly ever", "Some of time", "Most of the time", "All of the time"]
    },
    {
        question: "I feel tired and low on energy",
        options: ["Never", "Hardly ever", "Some of time", "Most of the time", "All of the time"]
    },
    {
        question: "I believe that nothing will ever work out for me",
        options: ["Never", "Hardly ever", "Some of time", "Most of the time", "All of the time"]
    },
    {
        question: "I have difficulty concentrating",
        options: ["Never", "Hardly ever", "Some of time", "Most of the time", "All of the time"]
    },
    {
        question: "I feel restless and anxious",
        options: ["Never", "Hardly ever", "Some of time", "Most of the time", "All of the time"]
    },
    {
        question: "I cry (or I feel like crying)",
        options: ["Never", "Hardly ever", "Some of time", "Most of the time", "All of the time"]
    },
    {
        question: "I have thoughts about ending my life",
        options: ["Never", "Hardly ever", "Some of time", "Most of the time", "All of the time"]
    },
    {
        question: "I feel like a failure",
        options: ["Never", "Hardly ever", "Some of time", "Most of the time", "All of the time"]
    },
    {
        question: "I feel like I am alone (or want to be alone)",
        options: ["Never", "Hardly ever", "Some of time", "Most of the time", "All of the time"]
    },
    {
        question: "It takes me a lot of effort to do the smallest of things",
        options: ["Never", "Hardly ever", "Some of time", "Most of the time", "All of the time"]
    },
    {

    }
];

export default questions;
